// Frequencia cardiaca — perfil BLE PADRAO (Heart Rate Service 0x180D,
// caracteristica Heart Rate Measurement 0x2A37, notify).
//
// Implementado AS CEGAS: o Coospo HW9 nao estava em maos quando isto foi
// escrito, mas o perfil e padronizado pelo Bluetooth SIG. Se o aparelho seguir a
// norma, funciona de primeira; se nao, uma captura de um minuto resolve.
//
// O sensor entrega bpm e, quando disponivel, os intervalos RR. NAO entrega
// tracado de ECG — nenhum sensor BLE de consumo entrega. Por isso o monitor
// mostra tendencia de bpm, nunca uma onda cardiaca (docs/PRODUCT.md §6.1).

export const FC_SERVICO = 0x180d;
export const FC_CARACTERISTICA = 0x2a37;

export interface MedidaFc {
  bpm: number;
  /** Intervalos entre batimentos, em segundos. Vazio se o sensor nao mandar. */
  intervalosRr: number[];
  /** undefined quando o sensor nao reporta contato com a pele. */
  contatoPele?: boolean;
  energiaGastaKj?: number;
}

export function decodificarFc(dados: DataView): MedidaFc | null {
  if (dados.byteLength < 2) return null;

  const flags = dados.getUint8(0);
  const bpmEm16Bits = (flags & 0x01) !== 0;
  const bpm = bpmEm16Bits ? dados.getUint16(1, true) : dados.getUint8(1);
  let i = bpmEm16Bits ? 3 : 2;

  const medida: MedidaFc = { bpm, intervalosRr: [] };

  // Bit 2 diz se o sensor sabe reportar contato; bit 1 e o estado do contato.
  if (flags & 0x04) medida.contatoPele = (flags & 0x02) !== 0;

  if (flags & 0x08 && i + 1 < dados.byteLength) {
    medida.energiaGastaKj = dados.getUint16(i, true);
    i += 2;
  }

  if (flags & 0x10) {
    for (; i + 1 < dados.byteLength; i += 2) {
      // RR vem em unidades de 1/1024 s.
      medida.intervalosRr.push(dados.getUint16(i, true) / 1024);
    }
  }

  return medida;
}
